export function Ornament({ className = "text-habanero", diamonds = true }) {
  const swash = (
    <svg width="72" height="20" viewBox="0 0 72 20" fill="none" className="shrink-0" aria-hidden="true">
      <path
        d="M2 14 C 14 4, 26 4, 34 10 C 38 13, 42 13, 46 10 C 54 4, 62 6, 70 12"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
    </svg>
  );
  return (
    <div className={`flex items-center justify-center gap-3 ${className}`} data-testid="ornament" aria-hidden="true">
      {swash}
      {diamonds && (
        <span className="flex gap-1.5">
          {[0, 1, 2, 3].map((i) => (
            <span key={i} className="inline-block h-1.5 w-1.5 rotate-45 bg-current" />
          ))}
        </span>
      )}
      <span className="-scale-x-100">{swash}</span>
    </div>
  );
}
